import { API_URL } from "utils/CONSTANTS";
import axios from "axios";

export const getWidget = (uid) =>
  axios.get(`${API_URL}/template/widget/${uid}/`);

export const checkIdentification = (data, uid) =>
  axios.post(`${API_URL}/template/widget-id/${uid}/`, data);

export const sendCollectedFeedback = ({ data, uid }) =>
  axios.post(`${API_URL}/template/widget/${uid}/`, data);

export const uploadMedia = ({ data }) =>
  axios.post(
    `${API_URL}/template/widget-upload-file${window.location.pathname}/`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
